const t = {
  name: "Spain",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 4V5.38197L14.4472 4.65836L15.3416 6.44721L14.236 7.00005L15.3415 7.55281L14.4471 9.34167L11.9999 8.11809L9.55263 9.34167L8.6582 7.55281L9.76378 7.00003L8.6582 6.44724L9.55263 4.65839L11 5.38207V4H13Z" fill="currentColor"/>
<path d="M16.2651 7.77789L17.7347 6.42133C19.0766 7.87496 19.9999 9.80888 19.9999 11.9996H17.9999C17.9999 10.3903 17.3233 8.92425 16.2651 7.77789Z" fill="currentColor"/>
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Spain
};
